import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import {
  Container,
  Typography,
  Box,
  Grid,
  Card,
  CardContent,
  CardActions,
  Button,
  Paper,
} from '@mui/material';
import {
  MenuBook as StudyIcon,
  Quiz as ExamIcon,
  ArrowBack as BackIcon,
} from '@mui/icons-material';

const areaNames = {
  matematicas: 'Matemáticas',
  'lectura-critica': 'Lectura Crítica',
  sociales: 'Sociales y Ciudadanas',
  ciencias: 'Ciencias Naturales',
  ingles: 'Inglés',
};

const areaColors = {
  matematicas: '#2196F3',
  'lectura-critica': '#9C27B0',
  sociales: '#FF9800',
  ciencias: '#4CAF50',
  ingles: '#F44336',
};

const AreaOptions = () => {
  const { area } = useParams();
  const navigate = useNavigate();

  const areaName = areaNames[area] || area;
  const color = areaColors[area] || '#2196F3';

  const handleStudy = () => {
    navigate(`/study/${area}/topics`);
  };

  const handleExam = () => {
    navigate(`/exam/${area}/config`);
  };

  const handleBack = () => {
    navigate('/dashboard');
  };

  return (
    <Container maxWidth="md" sx={{ mt: 4, mb: 4 }}>
      <Button
        startIcon={<BackIcon />}
        onClick={handleBack}
        sx={{ mb: 3 }}
      >
        Volver al Dashboard
      </Button>

      <Paper elevation={3} sx={{ p: 4, mb: 4, bgcolor: color, color: 'white' }}>
        <Typography variant="h3" gutterBottom align="center">
          {areaName}
        </Typography>
        <Typography variant="h6" align="center">
          ¿Qué deseas hacer?
        </Typography>
      </Paper>

      <Grid container spacing={3}>
        <Grid item xs={12} md={6}>
          <Card
            sx={{
              height: '100%',
              display: 'flex',
              flexDirection: 'column',
              transition: 'transform 0.2s',
              '&:hover': {
                transform: 'scale(1.05)',
              },
            }}
          >
            <CardContent sx={{ flexGrow: 1, textAlign: 'center', p: 4 }}>
              <StudyIcon sx={{ fontSize: 80, color: color, mb: 2 }} />
              <Typography variant="h4" gutterBottom>
                Estudiar
              </Typography>
              <Typography variant="body1" color="text.secondary">
                Revisa los contenidos teóricos organizados por temas específicos.
                Aprende los conceptos fundamentales de esta área.
              </Typography>
            </CardContent>
            <CardActions sx={{ justifyContent: 'center', pb: 3 }}>
              <Button
                variant="contained"
                size="large"
                onClick={handleStudy}
                sx={{
                  bgcolor: color,
                  '&:hover': { bgcolor: color, opacity: 0.9 },
                  px: 4,
                }}
              >
                Ir a Estudiar
              </Button>
            </CardActions>
          </Card>
        </Grid>

        <Grid item xs={12} md={6}>
          <Card
            sx={{
              height: '100%',
              display: 'flex',
              flexDirection: 'column',
              transition: 'transform 0.2s',
              '&:hover': {
                transform: 'scale(1.05)',
              },
            }}
          >
            <CardContent sx={{ flexGrow: 1, textAlign: 'center', p: 4 }}>
              <ExamIcon sx={{ fontSize: 80, color: color, mb: 2 }} />
              <Typography variant="h4" gutterBottom>
                Hacer Examen
              </Typography>
              <Typography variant="body1" color="text.secondary">
                Pon a prueba tus conocimientos. Configura el examen según temas
                específicos o incluye todos los temas del área.
              </Typography>
            </CardContent>
            <CardActions sx={{ justifyContent: 'center', pb: 3 }}>
              <Button
                variant="contained"
                size="large"
                onClick={handleExam}
                sx={{
                  bgcolor: color,
                  '&:hover': { bgcolor: color, opacity: 0.9 },
                  px: 4,
                }}
              >
                Configurar Examen
              </Button>
            </CardActions>
          </Card>
        </Grid>
      </Grid>

      <Box sx={{ mt: 4, p: 3, bgcolor: '#f5f5f5', borderRadius: 2 }}>
        <Typography variant="h6" gutterBottom>
          💡 Recomendación
        </Typography>
        <Typography variant="body2">
          Te sugerimos <strong>estudiar primero</strong> los temas que no dominas
          completamente antes de hacer el examen. Esto te ayudará a obtener mejores
          resultados y reforzar tu aprendizaje.
        </Typography>
      </Box>
    </Container>
  );
};

export default AreaOptions;
